function sortData(a, b) {
  if (a.lastUpdated > b.lastUpdated) return 1;
  if (a.lastUpdated < b.lastUpdated) return -1;
  return 0;
}

const getIntitials = name => {
  if (!name) {
    return '';
  }
  const [first, second] = name.split(' ');
  if (second) {
    return first.charAt(0) + second.charAt(0);
  }
  if (first) {
    return first.substring(0, 2);
  }
};

const searchParams = {
  apiType: {
    text: 'API Type',
    values: [
      {
        key: 'restApi',
        value: 'REST'
      },
      {
        key: 'asyncApi',
        value: 'Async'
      },
    ]
  }
};

export { sortData, getIntitials, searchParams };

